import RecapReport from './RecapReport';

export default RecapReport;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/RecapReport/index.tsx